import _ from "lodash";
import numeral from "numeral";
import { useEffect, useMemo, useState } from "react";
import { useBalanceStore } from "../../../_store/balanceStore";
import { useEducationStore } from "../../../_store/educationStore";
import { useRetireStore } from "../../../_store/retireStore";
import { useStrategyStore } from "../../../_store/strategyRetireStore";
import { useTaxStore } from "../../../_store/taxplanStore";
import HalfChartMain from "../../../components/chart/HalfChartMain";
import LineChartMain from "../../../components/chart/LineChartMain";
import { calculateBasicLiquidityRatio } from "../../../functions/Balance/basic-liquidity-ratio";
import { calculateDebtToTotalAssets } from "../../../functions/Balance/debt-to-total-assets";
import { calculateExpenseSummary } from "../../../functions/Balance/expense-summary";
import {
  sumCapitalInvest,
  sumDebtInvest,
} from "../../../functions/Balance/sumProperty";
import {
  SumDebtPersonalValue,
  SumOtherDebtAmount,
} from "../../../functions/Balance/sumValueBalance";
import {
  InvestmentReturnCal,
  InvestmentReturnNormalCal,
} from "../../../functions/retirement/retirementFunction";
import { InvestmentReturnCalAfter } from "../../../functions/retirement/retirementFunctionAfter";
import {
  TabThreeExpenseCalculation,
  TabThreeSumIncomeCalculation,
  TabThreeWithHoldingTax,
} from "../../../functions/taxFucntion/premium/tab3function";
import { calculateCurrentTaxPlanDeductionTotal } from "../../../functions/taxFucntion/current-tax-calculation";
import {
  sum408RecieveMoney,
  sum408property,
} from "../../../functions/taxFucntion/premium/tab4function";
import { cn, mapStatus } from "../../../utils/useFunctions";
import {
  ICON_BAHT,
  ICON_CHECK,
  ICON_CLOSE,
  ICON_GRAPH,
  ICON_STAR,
  ICON_WARNING,
} from "../../../utils/useIcons";
import { calPMTFVA } from "../../education/functions/function";
import {
  dataAge,
  dataAgeAF,
} from "../../retirement_plan/functions/functionRetriementPlan";
import { calculateTax, checkSum } from "../../tax_plan/functions";
import { PdfCard, PdfCardWhite } from "../component/pdf.c.card";
import PdfFooter from "../component/pdf.c.footer";
import PdfHeader from "../component/pdf.c.header";
import {
  PdfHeaderCardText,
  PdfHeaderText,
} from "../component/pdf.c.headerText";
import PdfLine from "../component/pdf.c.line";
import { STYLE_PAGE } from "../styles/pdf.style";

// สร้างหน้าภาพรวม PDF โดยใช้ owner กลางของสภาพคล่อง หนี้สิน และยอดรายจ่าย เพื่อให้ตัวเลขกับคำอธิบายอ้างอิงผลชุดเดียวกัน
function PdfPageOverviewOne({ page, userData }) {
  const balanceData = useBalanceStore((state) => state.balanceData);
  const retireData = useRetireStore((state) => state.retireData);
  const taxData = useTaxStore((state) => state.taxData);
  const strategy = useStrategyStore((state) => state.strategy);
  const educationData = useEducationStore((state) => state.educationData);

  const straigyLists = strategy?.map((item) => item?.key);

  const [ReturnInsurance, setReturnInsurance] = useState([]);
  const [addInvest, setAddInvest] = useState(
    balanceData?.property_invest_list ? balanceData?.property_invest_list : []
  );

  useEffect(() => {
    if (balanceData) {
      let tempInsuranceReturn = balanceData?.expenses_fixed_list
        ?.filter(
          (item) => item.options_expenses_fixed === "expenses_insuarant_life"
        )
        ?.map((item) => item.expenses_insuarant_lifes)
        ?.flat();

      let tempBalanceData = {};
      //=============เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)=============//

      if (
        balanceData?.property_invest_list
          ?.map((item) => item.options_property_invest_title)
          .includes("เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)") &&
        tempInsuranceReturn?.length === 0
      ) {
        // ถ้ามีหัวข้อนี้อยู่แล้ว
        let tempNameList = balanceData?.property_invest_list
          .find(
            (item) =>
              item?.options_property_invest_title ===
              "เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)"
          )
          ?.invest_other_lists?.filter((item) => item !== null)
          ?.map((item) => item?.title);

        let tempInvestList = balanceData?.property_invest_list?.map((item) => {
          if (item?.invest_other_lists) {
            let tempData = tempInsuranceReturn
              ?.map((item2) => {
                if (!tempNameList?.includes(item2.title))
                  return {
                    amount: item2?.more_details?.policy_surrender_value,
                    created: item2.created,
                    reward_amount_per_year: item?.reward_amount_per_year || 1,
                    target_invest: {},
                    title: item2.title,
                    editable: false,
                  };
              })
              .filter((item) => item !== undefined);
            return {
              ...item,
              invest_other_lists: [...item.invest_other_lists, ...tempData],
            };
          }
          return item;
        });

        tempBalanceData = tempInvestList;
      } else {
        // ถ้ายังไม่มีหัวข้อนี้อยู่
        let tempInvestList = tempInsuranceReturn?.map((item) => {
          return {
            amount: item?.more_details?.policy_surrender_value,
            created: item.created,
            reward_amount_per_year: item?.reward_amount_per_year || 1,
            target_invest: item?.target_invest || {},
            title: item.title,
            editable: true,
          };
        });

        tempBalanceData = tempInvestList;
      }
      setReturnInsurance(tempBalanceData);
    }
    //==============================================//
  }, [balanceData]);

  const displaySumBudget = () => {
    return calculateCurrentTaxPlanDeductionTotal(taxData);
  };

  const getCaltax = () => {
    let result = 0;
    result =
      taxData?.tax_income -
      taxData?.deduction_expenses -
      taxData?.deduct_summary;

    if (userData?.is_premium) {
      result =
        TabThreeSumIncomeCalculation(taxData, balanceData) -
        TabThreeExpenseCalculation(taxData, balanceData) -
        taxData?.deduct_summary +
        sum408property(taxData, balanceData) +
        sum408RecieveMoney(taxData);
    }

    return calculateTax(result);
  };

  const displaySumAfterTaxPaid = () => {
    let result = 0;
    result =
      Number(taxData?.tax_income) -
      Number(taxData?.deduction_expenses) -
      Number(taxData?.deduct_summary_af);

    if (userData?.is_premium) {
      result =
        TabThreeSumIncomeCalculation(taxData, balanceData) -
        TabThreeExpenseCalculation(taxData, balanceData) -
        Number(taxData?.deduct_summary || 0) -
        Number(displaySumBudget() || 0);
    }

    return calculateTax(result);
  };

  const displayTaxPaid = useMemo(() => {
    let result = calculateTax(taxData?.tax_income);
    if (userData?.is_premium) {
      result =
        TabThreeSumIncomeCalculation(taxData) +
        sum408property(taxData) +
        sum408RecieveMoney(taxData);
    }
    return result;
  }, [taxData?.tax_income]);

  const displaySumTax = useMemo(
    () => checkSum(getCaltax(), taxData?.after_tax_paid, 0, 0),
    [getCaltax(), taxData?.after_tax_paid, 0, 0]
  );

  const checkPercent = () => {
    let result = 0;
    result = ((getCaltax() - taxData?.after_tax_paid) / getCaltax()) * 100;
    if (isNaN(result)) {
      return 0;
    }
    return Number(result)?.toFixed(2);
  };

  const dataPlanBf = [
    ...InvestmentReturnCal(
      retireData,
      balanceData,
      strategy,
      educationData
    )?.map((bf_investment_assets) => {
      return bf_investment_assets?.asset_invest;
    }),
  ];

  const { totalAssets: sumProperty, ratio: valueDebttoTotalAsset } = useMemo(
    () =>
      calculateDebtToTotalAssets({
        balanceData,
        addInvest,
        returnInsurance: ReturnInsurance,
      }),
    [balanceData, addInvest, ReturnInsurance]
  );

  //ความมั่งคั่ง

  const getNetWealth = useMemo(() => {
    let result = 0;
    if (balanceData?.property_propotion) {
      result = balanceData?.debt_propotion
        ? sumProperty - Number(balanceData?.debt_propotion)
        : 0;
    }
    if (result > 0) {
      return result;
    } else {
      return 0;
    }
  }, [balanceData?.property_propotion, balanceData?.debt_propotion]);

  // สภาพคล่อง
  const {
    ratio: basicLiquidityRatio,
    status: basicLiquidityStatus,
  } = calculateBasicLiquidityRatio({ balanceData });
  const valueProperty = basicLiquidityRatio;
  const getPropertyStatus = () => basicLiquidityStatus;

  // หนี้สินต่อสินทรัพย์
  const getDebttoTotalAssetStatus = () => {
    if (!balanceData?.debt_propotion) return;

    if (valueDebttoTotalAsset > 50) {
      return "bad";
    }
    return "good";
  };

  // ชำระหนี้ต่อรายรับ
  const valueDebttoSalary = useMemo(() => {
    let sum = 0;
    const debtPermonth =
      balanceData?.sum_debt_short_permonth +
      balanceData?.sum_debt_long_permonth;
    const salaryPermonth = balanceData?.salary_propotion
      ? balanceData?.salary_propotion / 12
      : 0;
    sum = salaryPermonth > 0 ? (debtPermonth / salaryPermonth) * 100 : 0;
    return Number(sum || 0);
  }, [balanceData]);
  const getDebttoSalaryStatus = () => {
    if (
      !balanceData?.sum_debt_short_permonth &&
      !balanceData?.sum_debt_long_permonth
    )
      return;

    if (valueDebttoSalary > 50) {
      return "bad";
    }
    return "good_2";
  };

  // การออม
  const valueConservation = useMemo(() => {
    let sum = 0;
    if (balanceData?.sum_expenses_invest_saving) {
      sum = balanceData?.sum_expenses_invest_saving;
    }
    const finalResult =
      sum > 0 ? (sum / balanceData?.salary_propotion) * 100 : 0;
    return Number(finalResult || 0);
  }, [balanceData]);

  const getConservationStatus = () => {
    if (!balanceData?.sum_expenses_invest_saving) return;
    if (valueConservation <= 10) {
      return "bad";
    }
    return "good";
  };

  // การลงทุน
  const valueInvest = useMemo(() => {
    let sum = 0;
    if (
      SumDebtPersonalValue(balanceData) +
        sumCapitalInvest(addInvest, ReturnInsurance) +
        sumDebtInvest(balanceData) >
      0
    ) {
      sum =
        getNetWealth > 0
          ? ((SumDebtPersonalValue(balanceData) +
              sumCapitalInvest(addInvest, ReturnInsurance) +
              sumDebtInvest(balanceData)) /
              getNetWealth) *
            100
          : 0;
    }
    return Number(sum || 0);
  }, [balanceData]);

  const getInvestStatus = () => {
    if (
      SumDebtPersonalValue(balanceData) +
        sumCapitalInvest(addInvest, ReturnInsurance) +
        sumDebtInvest(balanceData) <=
      0
    )
      return;

    if (valueInvest > 50) {
      return "good";
    }
    return "bad";
  };

  // วางแผนเกษียณ
  const getInvestSum = InvestmentReturnCal(
    retireData,
    balanceData,
    strategy,
    educationData
  )?.map((bf_investment_assets, index) => {
    return {
      result: bf_investment_assets?.asset_invest,
      age: retireData?.bf_plan_age[index],
    };
  });
  const lastResultBF = getInvestSum[getInvestSum?.length - 1];
  const retirementAge = retireData?.age_retire;
  const retireBF = getInvestSum.find(
    (result) => result.age === retirementAge
  )?.result;

  const retirementAgeAF = straigyLists?.includes("strategy_age_retire")
    ? retireData?.strategy_age_retire
    : retireData?.age_retire;

  const getremainBF = getInvestSum?.filter((thisRemain, i) => {
    if (thisRemain?.result <= 0) return { ...thisRemain };
  })?.[0];
  const remainBF = getremainBF?.age - 1;
  const beforeDiffYear = retireData?.age_retire - retireData?.age_current;
  const sumBeforeRetireInvest = useMemo(() => {
    const convertedMonth = beforeDiffYear * 12;
    const sumPMT = calPMTFVA(
      // retireData?.investment_bf_retirement / 100 / 12,
      // convertedMonth,
      // -lastResultBF?.results * -1
      lastResultBF?.result < 0
        ? Math.abs(lastResultBF?.result)
        : lastResultBF?.result,
      retireData?.investment_bf_retirement / 100 / 12,
      convertedMonth
    );
    return sumPMT;
  }, [retireData]);
  const strategyChange = retireData?.strategy_sum ? true : false;

  const dataPlanAF = InvestmentReturnCalAfter(
    retireData,
    strategy,
    balanceData,
    educationData
  )?.map((af_investment_assets) => {
    return af_investment_assets?.asset_invest;
  });

  const getInvestSumAF = InvestmentReturnCalAfter(
    retireData,
    strategy,
    balanceData,
    educationData
  )?.map((af_investment_assets, index) => {
    return {
      result: af_investment_assets?.asset_invest,
      age: retireData?.af_plan_age[index],
    };
  });
  const strategyLists = strategy?.map((item) => item?.key);

  const lastResultAF = getInvestSumAF[getInvestSumAF?.length - 1];
  const getremainAF = getInvestSumAF?.filter((thisRemain, i) => {
    if (thisRemain?.result <= 0) return { ...thisRemain };
  })?.[0];
  const remainAF = Number(getremainAF?.age) - 1;
  const afterDiffYear = Math.abs(
    strategyLists?.includes("strategy_age_retire")
      ? retireData?.strategy_age_retire - retireData?.age_current
      : retireData?.age_retire - retireData?.age_current
  );

  const retireAF = getInvestSumAF.find(
    (result) => result.age === retirementAgeAF
  )?.result;

  const convertYearToMonth = (year) => {
    return year * 12;
  };

  const afterDiffYearCheck = strategyLists?.includes("strategy_age_retire")
    ? retireData?.strategy_age_retire - retireData?.age_current
    : retireData?.age_retire - retireData?.age_current;

  const sumAfterRetireInvest = useMemo(() => {
    const convertedMonth = convertYearToMonth(afterDiffYear);
    const calPercent = strategyLists?.includes(
      "strategy_investment_bf_retirement_change"
    )
      ? retireData?.strategy_investment_bf_retirement_change
      : retireData?.investment_bf_retirement;

    const sumPMT = calPMTFVA(
      Math.abs(lastResultAF?.result),
      calPercent / 100 / 12,
      convertedMonth
    );

    return sumPMT;
  }, [retireData, strategy]);

  const getDetailBF = () => {
    if (strategyChange) {
      if (lastResultBF?.result > 0) {
        return [
          {
            icon: <ICON_CHECK className=" w-[14px] h-[14px] text-maincyan" />,
            render: () => {
              return (
                <div className=" flex gap-1">
                  <div
                    className={cn("text-[10px] font-semibold flex space-x-1")}
                  >
                    <div className="font-normal">
                      {`เริ่มวางแผนเกษียณตอนอายุ `}
                      <span className="font-semibold">
                        {_.isNaN(retireData?.age_current)
                          ? "-"
                          : retireData?.age_current}
                      </span>
                      {` ปี ประมาณการณ์เมื่อเกษียณอายุตอน `}
                      <span className="font-semibold">{`${retireData?.age_retire}`}</span>{" "}
                      {`ปี
  จะมีสินทรัพย์ลงทุนรวม`}{" "}
                      <span className="font-semibold">{`${numeral(
                        retireBF
                      )?.format("0,0.00")} บาท`}</span>
                    </div>
                  </div>
                </div>
              );
            },
          },
          {
            icon: (
              <ICON_WARNING className=" w-[14px] h-[14px] text-mainyellow" />
            ),
            render: () => {
              return (
                <div className=" flex gap-1">
                  <div className="text-[10px] ">สามารถใช้จนได้ถึงอายุ</div>
                  <div className={cn("text-[10px] flex space-x-1")}>
                    <div className="font-semibold">
                      {retireData?.strategy_age_dead
                        ? retireData?.strategy_age_dead
                        : retireData?.age_dead || "-"}
                    </div>
                    <span className=" font-normal">ปี</span>
                    <div>แต่อย่าประมาทนะ</div>
                  </div>
                </div>
              );
            },
            // title: "สามารถใช้จนได้ถึงอายุ",
            // value: retireData?.strategy_age_dead
            //   ? retireData?.strategy_age_dead
            //   : retireData?.age_dead,
            // unit: "ปี แต่อย่าประมาทนะ",
          },
        ];
      }
      return [
        {
          icon: (
            <ICON_CHECK className=" w-[14px] h-[14px] text-maincyan flex-none" />
          ),
          render: () => {
            return (
              <div className=" flex gap-1">
                <div className="text-[10px] ">
                  {/* คาดการณ์สินทรัพย์เพื่อการลงทุน ณ อายุ{" "} */}
                  เริ่มวางแผนเกษียณตอนอายุ{" "}
                </div>
                <div className={cn("text-[10px] flex space-x-1")}>
                  <div className="font-semibold">
                    {_.isNaN(retireData?.age_current)
                      ? "-"
                      : retireData?.age_current}{" "}
                    ปี
                  </div>
                </div>
              </div>
            );
          },
        },
        {
          icon: <ICON_WARNING className=" w-[14px] h-[14px] text-mainyellow" />,
          render: () => {
            return (
              <div className=" flex flex-col">
                <div className="flex gap-1">
                  <div className="text-[10px] ">สามารถใช้จนได้ถึงอายุ</div>
                  <div className={cn("text-[10px] flex space-x-1")}>
                    <div className="font-semibold">
                      {_.isNaN(remainBF) ? "-" : remainBF} ปี
                    </div>
                  </div>
                </div>
              </div>
            );
          },
        },
        {
          icon: <ICON_CLOSE className=" w-[14px] h-[14px] text-maincyan" />,
          render: () => {
            return (
              <div className="flex flex-col">
                <div className=" flex gap-1">
                  <div className="text-[10px] ">
                    ถ้าต้องการมีเงินใช้จ่ายจนถึงอายุ{" "}
                  </div>
                  <div className={cn("text-[10px] font-semibold")}>
                    {_.isNaN(retireData?.age_dead) ? "-" : retireData?.age_dead}{" "}
                    ปี
                  </div>
                </div>
                <div>
                  <div className="text-[10px] ">
                    ยังขาดอยู่ทั้งหมด{" "}
                    <span className=" font-medium text-black">
                      {lastResultBF?.result < 0
                        ? numeral(lastResultBF?.result * -1)?.format("0,0")
                        : numeral(lastResultBF?.result)?.format("0,0")}
                      {""} บาท
                    </span>
                  </div>
                </div>
              </div>
            );
          },
        },
        {
          icon: <ICON_STAR className=" w-[14px] h-[14px] text-maingreen" />,
          render: () => {
            if (retireData?.age_retire - retireData?.age_current !== 0) {
              return (
                <div className="flex flex-col">
                  <div className=" flex gap-1">
                    <div className="text-[10px] ">ควรวางแผนลงทุนผลตอบแทน </div>
                    <div className={cn("text-[10px] font-semibold")}>
                      {_.isNaN(retireData?.investment_bf_retirement)
                        ? ""
                        : retireData?.investment_bf_retirement}{" "}
                      %
                    </div>
                  </div>
                  <div className="text-[10px] flex space-x-1">
                    <div>เป็นระยะเวลา</div>
                    <span className=" font-semibold">
                      {_.isNaN(beforeDiffYear) ? "-" : beforeDiffYear} ปี
                    </span>{" "}
                    <div>เดือนละ</div>
                    <span className=" font-semibold text-mainblue">
                      {numeral(sumBeforeRetireInvest)?.format("0,0")} บาท
                    </span>
                  </div>
                </div>
              );
            }

            return (
              <div className="flex flex-col">
                <div className="  text-[10px] ">
                  {`อย่าประมาทในการวางแผนเกษียณ ตอนคุณอายุ `}
                  <span className="font-semibold">
                    {_.isNaN(remainBF) ? "-" : remainBF} ปี
                  </span>
                  {` รายรับของคุณจะไม่พอใช้ ควรขยายเวลาเกษียณ หรือรีบหารายได้เพิ่มเติม`}
                </div>
              </div>
            );
          },
        },
      ];
    } else {
      if (lastResultBF?.result > 0) {
        return [
          {
            icon: <ICON_CHECK className=" w-[14px] h-[14px] text-maincyan" />,
            render: () => {
              return (
                <div className="text-[10px] flex flex-col gap-1">
                  <div className=" ">
                    คาดการณ์สินทรัพย์เพื่อการลงทุน ณ วันเกษียณอายุ
                  </div>
                  <div className="flex">
                    <span className="font-medium mr-1">
                      {_.isNaN(retireData?.age_retire)
                        ? "-"
                        : retireData?.age_retire}{" "}
                      ปี
                    </span>
                    <div className="flex space-x-1">
                      <div>จำนวน</div>
                      <span className=" font-medium text-mainblue">
                        {numeral(retireBF)?.format("0,0.00")}
                      </span>
                    </div>
                  </div>
                </div>
              );
            },
          },
          {
            icon: (
              <ICON_WARNING className=" w-[14px] h-[14px] text-mainyellow" />
            ),
            render: () => {
              return (
                <div className=" flex gap-1">
                  <div className="text-[10px] ">สามารถใช้จนได้ถึงอายุ</div>
                  <div className={cn("text-[10px] flex space-x-1")}>
                    <div className="font-semibold">
                      {_.isNaN(retireData?.age_dead)
                        ? "-"
                        : retireData?.age_dead}
                    </div>
                    <span className=" font-normal">ปี</span>
                    <div>แต่อย่าประมาทนะ</div>
                  </div>
                </div>
              );
            },
          },
        ];
      }
      return [
        {
          icon: <ICON_WARNING className=" w-[14px] h-[14px] text-mainyellow" />,
          render: () => {
            return (
              <div className=" flex gap-1">
                <div className="text-[10px] ">สามารถใช้จนได้ถึงอายุ</div>
                <div className={cn("text-[10px] flex space-x-1")}>
                  <div className="font-semibold">
                    {" "}
                    {_.isNaN(remainBF) ? "-" : remainBF} ปี
                  </div>
                </div>
              </div>
            );
          },
        },
        {
          icon: <ICON_CLOSE className=" w-[14px] h-[14px] text-mainred" />,
          render: () => {
            return (
              <div className="flex flex-col">
                <div className=" flex gap-1 flex-wrap ">
                  <div className="text-[10px] ">
                    ถ้าต้องการมีเงินใช้จ่ายจนถึงอายุ
                  </div>
                  <div className={cn("text-[10px] flex space-x-1")}>
                    <div className="font-semibold">
                      {_.isNaN(retireData?.age_dead)
                        ? "-"
                        : retireData?.age_dead}{" "}
                      ปี
                    </div>
                  </div>
                </div>
                <div className="flex gap-1 text-[10px]">
                  <div className="  text-[10px]">ยังขาดอยู่ทั้งหมด</div>
                  <div className={cn("text-[10px] font-semibold text-black")}>
                    {_.isNaN(lastResultBF?.result)
                      ? "-"
                      : numeral(
                          lastResultBF?.result < 0
                            ? lastResultBF?.result * -1
                            : lastResultBF?.result
                        ).format("0,0")}{" "}
                    บาท
                  </div>
                </div>
              </div>
            );
          },
        },
        {
          icon: <ICON_STAR className=" w-[14px] h-[14px] text-maincyan" />,
          render: () => {
            if (retireData?.age_retire - retireData?.age_current !== 0) {
              return (
                <div className="flex flex-col">
                  <div className=" flex gap-1">
                    <div className="text-[10px] ">ควรวางแผนลงทุนผลตอบแทน</div>
                  </div>
                  <div className={cn("text-[10px] font-semibold")}>
                    {retireData?.investment_bf_retirement}
                    <span className=" font-normal"> เป็นระยะเวลา </span>
                    <span className="font-semibold">
                      {_.isNaN(beforeDiffYear) ? "-" : beforeDiffYear} ปี{" "}
                    </span>
                    <span className="font-normal">เดือนละ </span>
                    <span className="text-mainblue">
                      {_.isNaN(sumBeforeRetireInvest)
                        ? "-"
                        : numeral(sumBeforeRetireInvest)?.format("0,0")}
                    </span>
                  </div>
                </div>
              );
            }

            return (
              <div className="flex flex-col">
                <div className="  text-[10px] ">
                  {`อย่าประมาทในการวางแผนเกษียณ ตอนคุณอายุ ${
                    _.isNaN(remainBF) ? "-" : remainBF
                  } ปี รายรับของคุณจะไม่พอใช้ ควรขยายเวลาเกษียณ หรือรีบหารายได้เพิ่มเติม`}
                </div>
              </div>
            );
          },
        },
      ];
    }
  };

  const getDetailAF = () => {
    if (strategyChange) {
      if (lastResultAF?.result > 0) {
        return [
          {
            icon: <ICON_CHECK className=" w-[14px] h-[14px] text-maincyan" />,
            render: () => {
              return (
                <>
                  <div className=" flex gap-1">
                    <div
                      className={cn("text-[10px] font-semibold flex space-x-1")}
                    >
                      <div className="font-normal">
                        {`เริ่มวางแผนเกษียณตอนอายุ `}
                        <span className="font-semibold">
                          {_.isNaN(retireData?.age_current)
                            ? "-"
                            : retireData?.age_current}
                        </span>
                        {` ปี ประมาณการณ์เมื่อเกษียณอายุตอน`}
                        <span className="font-semibold">{`${
                          straigyLists?.includes("strategy_age_retire")
                            ? retireData?.strategy_age_retire
                            : retireData?.age_retire
                        }`}</span>{" "}
                        {`ปี
  จะมีสินทรัพย์ลงทุนรวม`}{" "}
                        <span className="font-semibold">{`${numeral(
                          retireAF
                        )?.format("0,0.00")} บาท`}</span>
                      </div>
                    </div>
                  </div>
                </>
              );
            },
          },
          {
            icon: (
              <ICON_WARNING className=" w-[14px] h-[14px] text-mainyellow" />
            ),
            render: () => {
              return (
                <div className=" flex gap-1">
                  <div className="text-[10px] ">สามารถใช้จนได้ถึงอายุ</div>
                  <div className={cn("text-[10px] flex space-x-1")}>
                    <div className="font-semibold">
                      {retireData?.strategy_age_dead
                        ? retireData?.strategy_age_dead
                        : retireData?.age_dead || "-"}
                    </div>
                    <span className=" font-normal">ปี</span>
                    <div>แต่อย่าประมาทนะ</div>
                  </div>
                </div>
              );
            },
          },
        ];
      }
      return [
        {
          icon: (
            <ICON_CHECK className=" w-[14px] h-[14px] text-maincyan flex-none" />
          ),
          render: () => {
            return (
              <div className=" flex gap-1">
                <div className="text-[10px] ">
                  {/* คาดการณ์สินทรัพย์เพื่อการลงทุน ณ อายุ{" "} */}
                  เริ่มวางแผนเกษียณตอนอายุ{" "}
                </div>
                <div className={cn("text-[10px] flex space-x-1")}>
                  <div className="font-semibold">
                    {_.isNaN(retireData?.age_current)
                      ? "-"
                      : retireData?.age_current}{" "}
                    ปี
                  </div>
                </div>
              </div>
            );
          },
        },
        {
          icon: <ICON_WARNING className=" w-[14px] h-[14px] text-mainyellow" />,
          render: () => {
            return (
              <div className=" flex flex-col">
                <div className="flex gap-1">
                  <div className="text-[10px] ">สามารถใช้จนได้ถึงอายุ</div>
                  <div className={cn("text-[10px] flex space-x-1")}>
                    <div className="font-semibold">
                      {_.isNaN(remainAF) ? "-" : remainAF} ปี
                    </div>
                  </div>
                </div>
              </div>
            );
          },
        },
        {
          icon: <ICON_CLOSE className=" w-[14px] h-[14px] text-maincyan" />,
          render: () => {
            return (
              <div className="flex flex-col">
                <div className=" flex gap-1 flex-wrap ">
                  <div className="text-[10px] ">
                    ถ้าต้องการมีเงินใช้จ่ายจนถึงอายุ
                  </div>
                  <div className={cn("text-[10px] flex space-x-1")}>
                    <div className="font-semibold">
                      {_.isNaN(retireData?.age_dead)
                        ? "-"
                        : retireData?.age_dead}{" "}
                      ปี
                    </div>
                  </div>
                </div>
                <div className="flex gap-1 text-[10px]">
                  <div className="  text-[10px]">ยังขาดอยู่ทั้งหมด</div>
                  <div className={cn("text-[10px] font-semibold text-black")}>
                    {_.isNaN(lastResultAF?.result)
                      ? "-"
                      : numeral(
                          lastResultAF?.result < 0
                            ? lastResultAF?.result * -1
                            : lastResultAF?.result
                        ).format("0,0")}{" "}
                    บาท
                  </div>
                </div>
              </div>
            );
          },
        },
        {
          icon: <ICON_STAR className=" w-[14px] h-[14px] text-maingreen" />,
          render: () => {
            if (afterDiffYearCheck !== 0) {
              return (
                <div className="flex flex-col">
                  <div className=" flex gap-1">
                    <div className="text-[10px] ">ควรวางแผนลงทุนผลตอบแทน </div>
                    <div className={cn("text-[10px] font-semibold")}>
                      {strategyLists?.includes(
                        "strategy_investment_bf_retirement_change"
                      )
                        ? Math.abs(
                            retireData?.strategy_investment_bf_retirement_change
                          )
                        : Math.abs(retireData?.investment_bf_retirement)}{" "}
                      %
                    </div>
                  </div>
                  <div className="text-[10px] flex space-x-1">
                    <div>เป็นระยะเวลา</div>
                    <span className=" font-semibold">
                      {_.isNaN(afterDiffYear) ? "-" : afterDiffYear} ปี
                    </span>{" "}
                    <div>เดือนละ</div>
                    <span className=" font-semibold text-mainblue">
                      {numeral(sumAfterRetireInvest)?.format("0,0")} บาท
                    </span>
                  </div>
                </div>
              );
            }

            return (
              <div className="flex flex-col">
                <div className="  text-[10px]">
                  {`อย่าประมาทในการวางแผนเกษียณ ตอนคุณอายุ `}
                  <span className="font-semibold">
                    {_.isNaN(remainAF) ? "-" : remainAF} ปี
                  </span>
                  {` รายรับของคุณจะไม่พอใช้ ควรขยายเวลาเกษียณ หรือรีบหารายได้เพิ่มเติม`}
                </div>
              </div>
            );
          },
        },
      ];
    } else {
      if (lastResultAF?.result > 0) {
        return [
          {
            icon: <ICON_CHECK className=" w-[14px] h-[14px] text-maincyan" />,
            render: () => {
              return (
                <div className="text-[10px] flex flex-col gap-1">
                  <div className=" ">
                    คาดการณ์สินทรัพย์เพื่อการลงทุน ณ วันเกษียณอายุ
                  </div>
                  <div className="flex">
                    <span className="font-medium mr-1">
                      {_.isNaN(retireData?.age_retire)
                        ? "-"
                        : retireData?.age_retire}{" "}
                      ปี
                    </span>
                    <div className="flex space-x-1">
                      <div>จำนวน</div>
                      <span className=" font-medium text-mainblue">
                        {numeral(retireBF)?.format("0,0.00")}
                      </span>
                    </div>
                  </div>
                </div>
              );
            },
          },
          {
            icon: (
              <ICON_WARNING className=" w-[14px] h-[14px] text-mainyellow" />
            ),
            render: () => {
              return (
                <div className=" flex gap-1">
                  <div className="text-[10px] ">สามารถใช้จนได้ถึงอายุ</div>
                  <div className={cn("text-[10px] flex space-x-1")}>
                    <div className="font-semibold">
                      {_.isNaN(retireData?.age_dead)
                        ? "-"
                        : retireData?.age_dead}
                    </div>
                    <span className=" font-normal">ปี</span>
                    <div>แต่อย่าประมาทนะ</div>
                  </div>
                </div>
              );
            },
          },
        ];
      }
      return [
        {
          icon: <ICON_WARNING className=" w-[14px] h-[14px] text-mainyellow" />,
          render: () => {
            return (
              <div className=" flex gap-1">
                <div className="text-[10px] ">สามารถใช้จนได้ถึงอายุ</div>
                <div className={cn("text-[10px] flex space-x-1")}>
                  <div className="font-semibold">
                    {" "}
                    {_.isNaN(remainAF) ? "-" : remainAF} ปี
                  </div>
                </div>
              </div>
            );
          },
        },
        {
          icon: <ICON_CLOSE className=" w-[14px] h-[14px] text-mainred" />,
          render: () => {
            return (
              <div className="flex flex-col">
                <div className=" flex gap-1 flex-wrap ">
                  <div className="text-[10px] ">
                    ถ้าต้องการมีเงินใช้จ่ายจนถึงอายุ
                  </div>
                  <div className={cn("text-[10px] flex space-x-1")}>
                    <div className="font-semibold">
                      {_.isNaN(retireData?.age_dead)
                        ? "-"
                        : retireData?.age_dead}{" "}
                      ปี
                    </div>
                  </div>
                </div>
                <div className="flex gap-1 text-[10px]">
                  <div className="  text-[10px]">ยังขาดอยู่ทั้งหมด</div>
                  <div className={cn("text-[10px] font-semibold text-black")}>
                    {_.isNaN(lastResultAF?.result)
                      ? "-"
                      : numeral(
                          lastResultAF?.result < 0
                            ? lastResultAF?.result * -1
                            : lastResultAF?.result
                        ).format("0,0")}{" "}
                    บาท
                  </div>
                </div>
              </div>
            );
          },
        },
        {
          icon: <ICON_STAR className=" w-[14px] h-[14px] text-maincyan" />,
          render: () => {
            if (afterDiffYearCheck !== 0) {
              return (
                <div className="flex flex-col">
                  <div className=" flex gap-1">
                    <div className="text-[10px] ">ควรวางแผนลงทุนผลตอบแทน</div>
                  </div>
                  <div className={cn("text-[10px] font-semibold")}>
                    {retireData?.investment_af_retirement}
                    <span className=" font-normal"> เป็นระยะเวลา </span>
                    <span className="font-semibold">
                      {_.isNaN(afterDiffYear) ? "-" : afterDiffYear} ปี{" "}
                    </span>
                    <span className="font-normal">เดือนละ </span>
                    <span className="text-mainblue">
                      {_.isNaN(sumAfterRetireInvest)
                        ? "-"
                        : numeral(sumAfterRetireInvest)?.format("0,0")}
                    </span>
                  </div>
                </div>
              );
            }
            return (
              <div className="flex flex-col">
                <div className="  text-[10px]  ">
                  {`อย่าประมาทในการวางแผนเกษียณ ตอนคุณอายุ ${
                    _.isNaN(remainAF) ? "-" : remainAF
                  } ปี รายรับของคุณจะไม่พอใช้ ควรขยายเวลาเกษียณ หรือรีบหารายได้เพิ่มเติม`}
                </div>
              </div>
            );
          },
        },
      ];
    }
  };

  const getCanRetireText = (lastResult) => {
    let is_plan = balanceData?.is_plan ? true : false;

    if (!lastResult || !is_plan) {
      return "ยังไม่ได้วางแผน";
    }
    if (lastResult?.result > 0) {
      return "สามารถเกษียณได้";
    }
    return "ไม่สามารถเกษียณได้";
  };

  const isWealthy = Number(getNetWealth) > Number(balanceData?.debt_propotion);

  const isGoodBalance =
    balanceData?.debt_propotion >
    Number(balanceData?.sum_property_asset || 0) +
      SumDebtPersonalValue(balanceData) +
      sumCapitalInvest(addInvest, ReturnInsurance) +
      sumDebtInvest(balanceData) +
      Number(balanceData?.sum_property_private || 0) +
      SumOtherDebtAmount(balanceData) +
      Number(balanceData?.sum_property_intangible || 0)
      ? "bad"
      : "good";

  const netCashFlow =
    balanceData?.sum_salary_peryear +
    balanceData?.sum_interest_peryear +
    balanceData?.sum_other_income -
    (balanceData?.sum_expenses_fixed +
      balanceData?.sum_expenses_variable +
      balanceData?.sum_property_invest);
  const expenseSummary = calculateExpenseSummary(balanceData);

  return (
    <div
      style={{
        backgroundImage: `url(/images/bg_pdf.svg)`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "bottom right",
      }}
      className={cn(STYLE_PAGE)}
    >
      <PdfHeader />
      <PdfLine />
      <PdfHeaderText />
      <PdfCard className="space-y-2.5">
        {/* อัตราส่วนทางการเงิน */}
        <PdfCardWhite className={"flex flex-col pt-0"}>
          <div className="grid grid-cols-2 gap-6 mx-2.5 mt-2.5 ">
            {/* LEFT ITEMS */}
            <div className="flex flex-col space-y-1">
              <PdfHeaderCardText
                title="รายรับ - รายจ่าย"
                icon="/images/financial-analysis 1.svg"
                is_plan={balanceData?.is_plan ? true : false}
              />
              {[
                {
                  title: "รายรับรวมทั้งหมด",
                  value: balanceData?.salary_propotion,
                  classNameValue: "text-maingreen",
                },
                {
                  title: "รายจ่ายรวมทั้งหมด",
                  value: expenseSummary.expenseIncludingAllocation,
                  classNameValue: "text-mainorange",
                },
                {
                  title: "กระแสเงินสดสุทธิ",
                  value: Math.abs(netCashFlow),
                  classNameValue: "text-mainpurple",
                },
              ]?.map((item, index) => {
                return (
                  <div key={index} className="flex justify-between">
                    <div className="text-[12px] font-medium">{item?.title}</div>
                    <div
                      className={cn(
                        "text-[12px] font-bold ",
                        item?.classNameValue
                      )}
                    >
                      {numeral(item?.value).format("0,0")} บาท
                    </div>
                  </div>
                );
              })}
              <div className="flex justify-start">
                <div
                  className={cn("text-xs font-medium ")}
                >{`*เมื่อกระแสเงินสดสุทธิเป็นบวก ระบบสมมติให้บันทึกเป็นรายจ่ายเพื่อการออม/ลงทุน (${numeral(
                  expenseSummary.expenseBeforeAllocation
                ).format("0,0")} + ${numeral(
                  expenseSummary.positiveResidualAllocation
                ).format("0,0")} = ${numeral(
                  expenseSummary.expenseIncludingAllocation
                ).format("0,0")} บาท)`}</div>
              </div>
            </div>

            {/* RIGHT ITEMS */}
            <div className="flex flex-col space-y-1">
              <PdfHeaderCardText
                title="อัตราส่วนทางการเงิน"
                icon="/images/financial-analysis 1.svg"
                is_plan={balanceData?.is_plan ? true : false}
              />
              {[
                {
                  title: "สภาพคล่อง",
                  value: valueProperty,
                  status: getPropertyStatus(),
                  prefixValue: "เท่า",
                  formatValue: "0[.]00",
                },
                {
                  title: "หนี้สินต่อสินทรัพย์",
                  value: valueDebttoTotalAsset,
                  status: getDebttoTotalAssetStatus(),
                  prefixValue: "%",
                  formatValue: "0.00",
                },
                {
                  title: "การชำระหนี้ต่อรายรับ",
                  value: valueDebttoSalary,
                  status: getDebttoSalaryStatus(),
                  prefixValue: "%",
                  formatValue: "0.00",
                },
                {
                  title: "การออม",
                  value: valueConservation,
                  status: getConservationStatus(),
                  prefixValue: "%",
                  formatValue: "0.00",
                },
                {
                  title: "การลงทุน",
                  value: valueInvest,
                  status: getInvestStatus(),
                  prefixValue: "%",
                  formatValue: "0.00",
                },
              ]?.map((item, index) => {
                return (
                  <div key={index} className="flex justify-between">
                    <div className="flex space-x-2">
                      <div className="text-[12px] font-[500]">
                        {item?.title}
                      </div>
                      {mapStatus(item?.status) !== "ไม่มีข้อมูล" && (
                        <div className="text-[12px] text-mainblue font-bold ">
                          {numeral(item?.value).format(item.formatValue ?? "0")}{" "}
                          {item?.prefixValue}
                        </div>
                      )}
                    </div>

                    <div
                      className={cn(
                        "text-[12px] font-bold ",
                        {
                          "text-[#FF0000]": item?.status === "bad",
                          "text-maingreen": ["good", "good_2"].includes(
                            item?.status
                          ),
                          "text-mainblue": item?.status === "chance",
                          "text-maingray":
                            mapStatus(item?.status) === "ไม่มีข้อมูล",
                        },
                        item?.classNameValue
                      )}
                    >
                      {mapStatus(item?.status)}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </PdfCardWhite>

        {/* ความั่งคั่งสุทธิ & วางแผนภาษี & ก่อนเกษียณ หลังเกษียณ*/}
        <div className=" grid grid-cols-2 gap-2.5 ">
          {/* ความั่งคั่งสุทธิ */}
          <PdfCardWhite className={"flex flex-col  "}>
            <PdfHeaderCardText
              title="งบดุล"
              icon="/images/wealth.svg"
              is_plan={balanceData?.is_plan ? true : false}
            />
            {isGoodBalance === "good" && (
              <div className=" grid grid-cols-5 gap-2 w-full h-full">
                <div className=" w-full h-full bg-[#C4F3BD] rounded-[4px]  col-span-3">
                  <div className=" flex flex-col justify-center items-center h-full ">
                    <img
                      src="/images/wealth_green.svg"
                      className="w-6 h-6"
                      alt=""
                    />
                    <div className=" text-mainblue font-medium text-[12px] mt-[3px] ">
                      สินทรัพย์
                    </div>
                    <div className="text-mainblue font-semibold text-[12px] leading-3 pt-1">
                      {numeral(sumProperty).format("0,0")} บาท
                    </div>
                  </div>
                </div>
                <div className=" grid grid-rows-5 gap-[6px]  col-span-2">
                  <div
                    className={
                      " bg-[#FFCCCC] w-full h-full  rounded-[4px] py-2 " +
                      (isWealthy ? "row-span-2 " : "row-span-3 ")
                    }
                  >
                    <div className=" flex flex-col justify-center items-center h-full ">
                      {!isWealthy && (
                        <img
                          src="/images/debt_pdf2.svg"
                          className="w-6 h-6"
                          alt=""
                        />
                      )}
                      <div className=" text-mainblue font-medium text-[12px] mt-[3px] ">
                        หนี้สิน
                      </div>
                      <div className="text-mainblue font-semibold text-[12px] leading-3 pt-1">
                        {numeral(balanceData?.debt_propotion).format("0,0")} บาท
                      </div>
                    </div>
                  </div>
                  <div
                    className={
                      " bg-[#CEE3FF] w-full h-full rounded-[4px] py-2 " +
                      (isWealthy ? "row-span-3 " : "row-span-2 ")
                    }
                  >
                    <div className=" flex flex-col justify-center items-center h-full ">
                      {isWealthy && (
                        <img
                          src="/images/wealth_blue.svg"
                          className="w-6 h-6"
                          alt=""
                        />
                      )}
                      <div className=" text-mainblue font-medium text-[12px] mt-[3px] ">
                        ความมั่งคั่งสุทธิ
                      </div>
                      <div className="text-mainblue font-semibold text-[12px] leading-3 pt-1">
                        {numeral(getNetWealth).format("0,0")} บาท
                        {/* {numeral(balanceData?.net_wealth).format("0,0")} บาท */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {isGoodBalance === "bad" && (
              <div className="h-full">
                <div className=" grid grid-cols-2 gap-2 w-full h-full ">
                  <div className="grid grid-rows-5 gap-2">
                    <div className=" row-span-2"></div>
                    <div className=" w-full h-full bg-[#C4F3BD] rounded-[4px] row-span-3 p-1.5 ">
                      <div className=" flex flex-col justify-center items-center h-full ">
                        <img
                          src="/images/wealth_green.svg"
                          className="w-6 h-6"
                        />
                        <div className="text-mainblue font-medium text-[12px] mt-[3px] ">
                          สินทรัพย์
                        </div>
                        <div className="text-mainblue font-semibold text-[12px] leading-3 pt-1">
                          {numeral(
                            Number(balanceData?.sum_property_asset || 0) +
                              SumDebtPersonalValue(balanceData) +
                              sumCapitalInvest(addInvest, ReturnInsurance) +
                              sumDebtInvest(balanceData) +
                              Number(balanceData?.sum_property_private || 0) +
                              SumOtherDebtAmount(balanceData) +
                              Number(balanceData?.sum_property_intangible || 0)
                          ).format("0,0")}{" "}
                          บาท
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className=" w-full bg-[#FFCCCC] rounded-[4px] h-full p-1.5">
                    <div className=" flex flex-col justify-center items-center h-full ">
                      <img src="/images/wealth_bad.svg" className="w-6 h-6" />
                      <div className=" text-mainblue font-medium text-[12px] mt-[3px] ">
                        หนี้สิน
                      </div>
                      <div className="text-mainblue font-semibold text-[12px] pt-1">
                        {numeral(balanceData?.debt_propotion).format("0,0")} บาท
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className=" border border-mainyellow rounded-[10px]  mx-9 mt-2.5 p-1 flex gap-[6px] items-center">
                  <ICON_WARNING className={` w-7 h-7 text-mainyellow`} />
                  <div className=" text-sm text-center text-mainblue">
                    <div>หากมีหนี้สินมากกว่าสินทรัพย์</div>
                    <div>ต้องระมัดระวังในการใช้จ่ายเงิน</div>
                  </div>
                </div> */}
              </div>
            )}
          </PdfCardWhite>

          {/* วางแผนภาษี */}
          <PdfCardWhite className={" flex flex-col "}>
            <PdfHeaderCardText
              title="วางแผนภาษี"
              icon="/images/tax.svg"
              is_plan={taxData?.is_plan_tax ? true : false}
            />
            <div className=" px-2.5">
              <HalfChartMain
                // className="  mt-10"
                // margin=" -mt-96 "
                chartWidth={"w-[118px] mt-10"}
                fontSize="text-sm"
                text={false}
                value={`0`}
                beforevalue={Number(getCaltax() || 0)}
                aftervalue={
                  taxData?.is_plan_tax === true
                    ? Number(taxData?.after_tax_paid || 0)
                    : Math.abs(displaySumAfterTaxPaid())
                }
                maxvalue={Number(displayTaxPaid || 0)}
                // chartWidth="w-[170px]"
                // fontSize="text-[15px]"
                mtText="-mt-12"
              />
              <div className=" flex justify-center gap-2.5 w-full -mt-[60px]">
                <div
                  className={`bg-gray50 text-[10px] rounded-md py-[7px] px-2 w-20 text-mainblue font-semibold mt-1 h-4 flex gap-[5px] justify-center items-center`}
                >
                  <ICON_GRAPH className="w-[14px] h-[14px] text-maincyan " />
                  <span className=" flex-none"> {checkPercent()} %</span>
                </div>
                <div
                  className={`bg-gray50 text-[10px] rounded-md py-[7px] px-2 w-20 text-mainblue font-semibold mt-1 h-4 flex gap-[5px] justify-center items-center`}
                >
                  <ICON_BAHT className="w-[14px] h-[14px] text-maincyan " />
                  {numeral(displaySumTax).format("0,0")}
                </div>
              </div>
              <div className="flex flex-col space-y-1 mt-1">
                {[
                  {
                    title: "ก่อนวางแผน",
                    value:
                      String(getCaltax()) === "Infinity" ? "0" : getCaltax(),
                    classNameValue: "text-mainred",
                  },
                  {
                    title: "หลังวางแผน",
                    value:
                      String(displaySumAfterTaxPaid()) === "Infinity"
                        ? "0"
                        : displaySumAfterTaxPaid(),
                    classNameValue: "text-maingreen",
                  },
                  {
                    title: "ภาษีหัก ณ ที่จ่าย",
                    value: TabThreeWithHoldingTax(taxData, balanceData),
                    classNameValue: "text-mainblue",
                  },
                ]?.map((item, index) => {
                  return (
                    <div key={index} className="flex justify-between">
                      <div className="text-[10px] font-medium">
                        {item?.title}
                      </div>
                      <div
                        className={cn("text-[10px] font-medium  text-mainblue")}
                      >
                        <span
                          className={cn(
                            " mr-2.5 font-semibold",
                            item?.classNameValue
                          )}
                        >
                          {" "}
                          {numeral(item?.value).format("0,0")}
                        </span>{" "}
                        บาท
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className=" flex justify-center items-center gap-[5px] font-semibold text-xs mt-1">
                <div className=" ">
                  {Number(taxData?.final_tax || 0) +
                    sum408property(taxData) +
                    sum408RecieveMoney(taxData) +
                    Number(taxData?.tax_QuitJob?.moreTax || 0) <
                  0
                    ? "ขอคืนได้อีก"
                    : "ภาษีที่ต้องจ่าย"}
                </div>
                {/* <div className=" text-mainorange"> */}
                {/* text-maincyan */}
                <div className=" ">
                  {taxData?.is_plan_tax === true
                    ? numeral(
                        Math.abs(
                          Number(taxData?.final_tax || 0) +
                            Number(sum408property(taxData) || 0) +
                            Number(sum408RecieveMoney(taxData) || 0) +
                            Number(taxData?.tax_QuitJob?.moreTax || 0)
                        )
                      )?.format("0,0")
                    : numeral(Math.abs(displaySumAfterTaxPaid()))?.format(
                        "0,0"
                      )}{" "}
                  บาท
                </div>
              </div>
            </div>
          </PdfCardWhite>

          {/* ก่อนวางแผน */}
          <PdfCardWhite className={"flex flex-col  "}>
            <PdfHeaderCardText
              title={`ก่อนวางแผน ${
                getCanRetireText(lastResultBF) !== "ยังไม่ได้วางแผน"
                  ? `(${getCanRetireText(lastResultBF)})`
                  : ""
              }`}
              icon="/images/retire_bf.svg"
              is_plan={getCanRetireText(lastResultBF) !== "ยังไม่ได้วางแผน"}
            />
            <div className=" px-4 w-[220px] mx-auto">
              <LineChartMain
                axisSize={6}
                labels={dataAge()}
                dataPlan={dataPlanBf}
                fontSize="text-[10px]"
                head={`สินทรัพย์เพื่อการลงทุนสุทธิ`}
              />
            </div>
            <div className="flex flex-col space-y-1 mt-1">
              {getDetailBF()?.map((item, index) => {
                return (
                  <div key={index} className="flex gap-2.5">
                    <div>{item?.icon}</div>
                    {item?.render && item?.render()}
                  </div>
                );
              })}
            </div>
          </PdfCardWhite>

          {/* หลังวางแผน */}
          <PdfCardWhite className={"flex flex-col  "}>
            <PdfHeaderCardText
              title={`หลังปรับกลยุทธ์ ${
                getCanRetireText(lastResultAF) !== "ยังไม่ได้วางแผน"
                  ? `(${getCanRetireText(lastResultAF)})`
                  : ""
              }`}
              icon="/images/retire_bf.svg"
              is_plan={getCanRetireText(lastResultAF) !== "ยังไม่ได้วางแผน"}
            />
            <div className=" px-4 w-[220px] mx-auto">
              <LineChartMain
                axisSize={6}
                labels={dataAgeAF()}
                dataPlan={dataPlanAF}
                fontSize="text-[10px]"
                head={`สินทรัพย์เพื่อการลงทุนสุทธิ`}
              />
            </div>
            <div className="flex flex-col space-y-1 mt-1">
              {getDetailAF()?.map((item, index) => {
                return (
                  <div key={index} className="flex gap-2.5">
                    <div>{item?.icon}</div>
                    {item?.render && item?.render()}
                  </div>
                );
              })}
            </div>
          </PdfCardWhite>
        </div>
      </PdfCard>
      <PdfFooter page={page} />
    </div>
  );
}

export default PdfPageOverviewOne;
